export enum CareerStatus {
    FRESHER = 'fresher',
    WORKING = 'working'
}

export enum EducationLevel {
    HIGH_SCHOOL = 'High School / 10th',
    HIGHER_SECONDARY = 'Higher Secondary / 12th / PUC',
    ITI = 'ITI (Industrial Training Institute)',
    DIPLOMA = 'Diploma',
    BA = 'B.A.',
    BSC = 'B.Sc.',
    BCOM = 'B.Com',
    BCA = 'BCA',
    BBA = 'BBA',
    BTECH = 'B.Tech. / B.E.',
    BARCH = 'B.Arch.',
    BPHARM = 'B.Pharm.',
    BDS = 'BDS',
    MBBS = 'MBBS',
    BED = 'B.Ed.',
    LLB = 'LL.B.',
    BSW = 'BSW',
    BHM = 'BHM',
    BFA = 'BFA',
    BPT = 'BPT',
    BAMS = 'BAMS',
    BHMS = 'BHMS',
    MA = 'M.A.',
    MSC = 'M.Sc.',
    MCOM = 'M.Com.',
    MCA = 'MCA',
    MBA = 'MBA / PGDM',
    MTECH = 'M.Tech. / M.E.',
    MARCH = 'M.Arch.',
    MPHARM = 'M.Pharm.',
    MDS = 'MDS',
    MED = 'M.Ed.',
    LLM = 'LL.M.',
    MSW = 'MSW',
    MFA = 'MFA',
    MPT = 'MPT',
    MD = 'MD',
    MS_MEDICAL = 'MS (Medical)',
    MPHIL = 'M.Phil.',
    PHD = 'Ph.D. / Doctorate',
    POSTDOC = 'Postdoctoral Fellowship',
    CA = 'CA (Chartered Accountant)',
    CMA = 'CMA / ICWA',
    CS = 'CS (Company Secretary)',
    CFA = 'CFA',
    PROF_CERT = 'Professional Certification',
    OTHER = 'Other'
}

/**
 * Registration course (COURSES_LIST) -> profile EducationLevel. Used to
 * pre-fill "Highest education" when only the registration course is known.
 */
export const COURSE_TO_EDUCATION_LEVEL: Record<string, EducationLevel> = {
    'B.Tech': EducationLevel.BTECH,
    'B.E': EducationLevel.BTECH,
    'BCA': EducationLevel.BCA,
    'B.Sc': EducationLevel.BSC,
    'B.Com': EducationLevel.BCOM,
    'BBA': EducationLevel.BBA,
    'MBA': EducationLevel.MBA,
    'MCA': EducationLevel.MCA,
    'M.Tech': EducationLevel.MTECH,
    'M.Sc': EducationLevel.MSC,
    'M.Com': EducationLevel.MCOM,
    'Diploma': EducationLevel.DIPLOMA,
    'PhD': EducationLevel.PHD,
    'Other': EducationLevel.OTHER
};

export enum ExperienceYears {
    LESS_THAN_ONE = 'Less than 1 year',
    ONE = '1 year',
    TWO = '2 years',
    THREE = '3 years',
    FOUR = '4 years',
    FIVE = '5 years',
    SIX = '6 years',
    SEVEN = '7 years',
    EIGHT = '8 years',
    NINE = '9 years',
    TEN_PLUS = '10+ years',
    FIFTEEN_PLUS = '15+ years',
    TWENTY_PLUS = '20+ years'
}

export enum JobCategory {
    SOFTWARE_DEVELOPMENT = 'Software Development',
    ANDROID_ML = 'Android & ML',
    ADOBE_ANALYTICS_AI = 'Adobe Analytics & AI',
    CYBERSECURITY = 'Cybersecurity',
    QUICK_LEARNING = 'Quick Learning',
    PRODUCT_MANAGEMENT = 'Product Management',
    UX_UI_DESIGN = 'UX/UI Design',
    BUSINESS_ANALYST = 'Business Analyst',
    MANAGEMENT = 'Management',
    RECOMMENDATION = 'Recommendation',
    DEVOPS_SYSTEM_ACCOUNTING = 'DevOps/System Accounting',
    OPERATIONS = 'Operations',
    OPERATIONAL_SUPPORT = 'Operational Support',
    MECHANICAL_ENGINEERING = 'Mechanical Engineering',
    DIGITAL_MARKETING = 'Digital Marketing',
    PROJECT_MANAGEMENT = 'Project Management'
}
